import React, { Component } from "react";
import { HashLink as Link } from "react-router-hash-link";
import Collapsible from "./collapsible";

export default class Sidebar extends Component {
  constructor() {
    super();
    this.state = {
      index: -1,
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle(index) {
    if (index === this.state.index) index = -1;
    this.setState({ index });
  }

  render() {
    return (
      <div>
        <div>
          <nav
            href="#navbar"
            className="js-colorlib-nav-toggle colorlib-nav-toggle"
            data-toggle="collapse"
            data-target="#navbar"
            aria-expanded="false"
            aria-controls="navbar"
          >
            <i />
          </nav>
          <aside id="colorlib-aside">
            <div className="text-center">
              {/* <h4>
                <font color="red">双重</font>乐趣
              </h4> */}
              <a href="/#Home">
                <div
                  className="logo"
                  alt="Double The Fun Logo"
                  style={{ backgroundImage: "url(/images/doublethefun.png)" }}
                />
              </a>
              <h3>
                <font color="red">D</font>ouble <font color="red">T</font>he <font color="red">F</font>un
              </h3>
            </div>
            <nav id="main-menu">
              <div id="navbar" className="collapse">
                <ul>
                  <li>
                    <Collapsible
                      toggle={this.toggle}
                      title={
                        <Link to="/" data-nav-section="Home">
                          Home
                        </Link>
                      }
                      index={0}
                      show={this.state.index === 0}
                      headerClassName=""
                      contentClassName=""
                      headerColor="backcolor-blue"
                    ></Collapsible>
                  </li>
                  <li>
                    <Collapsible
                      toggle={this.toggle}
                      title={
                        <Link to="/rumba" data-nav-section="rumba">
                          Rumba&nbsp;
                          <img
                            src="/images/rumba/icon.png"
                            alt="Rumba - Ballroom Dancing"
                            height="40"
                            width="40"
                          />
                        </Link>
                      }
                      index={1}
                      show={this.state.index === 1}
                      contentClassName="submenu"
                      headerColor="backcolor-blue"
                    >
                      <Link to="/rumba/faq" data-nav-section="faq">
                        F.A.Q.
                      </Link>
                    </Collapsible>
                  </li>
                  {/* <li>
                    <Collapsible
                      toggle={this.toggle}
                      title={
                        <Link to="/xxoo10" data-nav-section="xxoo10">
                          XXOO 10 &nbsp;
                          <img
                            src="/images/xxoo10/icon.png"
                            alt="XXOO 10 - Multiplayer Tic Tac Toe"
                            height="20"
                            width="20"
                          />
                        </Link>
                      }
                      index={2}
                      show={this.state.index === 2}
                      contentClassName="submenu"
                      headerColor="backcolor-blue"
                    >
                      <Link to="/xxoo10/faq" data-nav-section="faq">
                        F.A.Q.
                      </Link>
                    </Collapsible>
                  </li>
                  <li>
                    <Collapsible
                      toggle={this.toggle}
                      title={
                        <Link to="/ufit" data-nav-section="ufit">
                          Workout...
                          <img
                            src="/images/ufit/icon.png"
                            alt="Workout Routines: Customizable Fitness Routines"
                            height="30"
                            width="40"
                          />
                        </Link>
                        
                      }
                      index={3}
                      show={this.state.index === 3}
                      contentClassName="submenu"
                      headerColor="backcolor-blue"
                    >
                      <Link to="/ufit/faq">F.A.Q.</Link>
                    </Collapsible>
                  </li>
                  <li>
                    <Collapsible
                      toggle={this.toggle}
                      title={<Link to="/#About">About Us</Link>}
                      index={4}
                      show={this.state.index === 4}
                      headerClassName=""
                      contentClassName=""
                      headerColor="backcolor-blue"
                    ></Collapsible>
                  </li> */}
                  <li>
                    <Collapsible
                      toggle={this.toggle}
                      title={<Link to="/ContactUs">Contact Us</Link>}
                      index={5}
                      show={this.state.index === 5}
                      headerClassName=""
                      contentClassName=""
                      headerColor="backcolor-blue"
                    ></Collapsible>
                  </li>
                </ul>
              </div>
            </nav>

            <div className="footer">
              {/* <div>
                <em>Is there a project we can help you with?</em>
              </div> */}
              {/* <ul>
                <li>
                  <a
                    href="https://www.facebook.com/doublethefun"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Facebook"
                  >
                    <i className="icon-facebook2" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/doublethefun"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Twitter"
                  >
                    <i className="icon-twitter2" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/doublethefun/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Instagram"
                  >
                    <i className="icon-instagram" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCFat3bhmjThVfG7YTVrVrEg"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Youtube"
                  >
                    <i className="icon-youtube" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.tiktok.com/@doublethefun?sender_device=pc&sender_web_id=6883294966048327173&is_from_webapp=1"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Tik Tok"
                  >
                    <i className="icon-TikTok"></i>
                  </a>
                </li>
              </ul> */}
              <ul>
                <li>
                  <Link to="/Privacy">Privacy Notice</Link>
                </li>
                <li>
                  <Link to="/tos">Terms Of Service</Link>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    );
  }
}
